import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M11.89 6.299A3.881 3.881 0 0 1 12.988 9a3.878 3.878 0 0 1-1.192 2.796l.848.848A5.078 5.078 0 0 0 14.188 9c0-1.381-.556-2.63-1.45-3.55l-.848.849zM0 5v8h5l5 5V0L5 5H0zm5.849.849L8.8 2.897v12.206l-2.951-2.952-.352-.351H1.2V6.2h4.297l.352-.351z" />
  </svg>
);

export default SvgComponent;
